interface SEOHeadProps {
  title: string;
  description: string;
  keywords?: string;
  canonical?: string;
  ogImage?: string;
  ogType?: string;
  schema?: object;
}

export default function SEOHead({
  title,
  description,
  keywords,
  canonical,
  ogImage = 'https://readdy.ai/api/search-image?query=Dramatic%20dark%20editorial%20news%20style%20graphic%20with%20warm%20orange%20accents%2C%20mystery%20and%20intrigue%20theme%2C%20abstract%20paparazzi%20silhouettes%2C%20premium%20visual%20design&width=1200&height=630&seq=og-default&orientation=landscape',
  ogType = 'website',
  schema,
}: SEOHeadProps) {
  const baseUrl = 'http://lalaccu.cn/';
  const fullCanonical = canonical ? `${baseUrl}${canonical}` : baseUrl;

  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={fullCanonical} />

      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={fullCanonical} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:site_name" content="51app" />
      <meta property="og:locale" content="zh_CN" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />

      {/* Geo tags */}
      <meta name="geo.region" content="CN-ZJ" />
      <meta name="geo.placename" content="Hangzhou" />
      <meta name="geo.position" content="30.2741;120.1551" />

      {/* Schema.org JSON-LD */}
      {schema && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(schema),
          }}
        />
      )}
    </>
  );
}